export default __webpack_public_path__ + "static/media/logoTiktok.524c6451.png";